import { Injectable, OnDestroy } from '@angular/core';
import { INDEXDBTABLES, key_Path, table_Index } from '@app/shared/enum/indexdb.enum';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IndexDbService implements OnDestroy {
  private INDEXDBNAME = 'iBDB';
  protected _db!: IDBDatabase;
  protected onDestroy$: Subject<void>;
  // change each time indexdb schema change
  private currentVersion = 10;
  constructor() {
    this._initIndexDb();
    this.onDestroy$ = new Subject();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  private _initIndexDb() {
    const indexedDB =
      window.indexedDB ||
      (window as any).mozIndexedDB ||
      (window as any).webkitIndexedDB ||
      (window as any).msIndexedDB ||
      (window as any).shimIndexedDB;

    if (!indexedDB) {
      console.log("IndexedDB could not be found in this browser.");
    }

    const request = indexedDB.open(this.INDEXDBNAME, this.currentVersion);

    request.onsuccess = () => {
      // Create DB connection
      this._db = request.result;
    };


    request.onerror = (event: any) => {
      console.error("An error occurred with IndexedDB");
      console.error(event);
    };

    request.onupgradeneeded = () => {
      const db = request.result;
      this.dbUpgradeneed(db);
    }
  }

  public removeIndexDb() {
    // INDEXDBTABLES.forEach((table) => {
    //   if (this._db?.objectStoreNames?.contains(table)) {
    //     this._db.transaction(table, 'readwrite').objectStore(table).clear();
    //   }
    // })
    window.indexedDB.deleteDatabase(this.INDEXDBNAME);
  }

  protected dbUpgradeneed(db: IDBDatabase) {
    INDEXDBTABLES.forEach((table) => {
      try {
        const store = db.createObjectStore(table, { keyPath: key_Path[table] });
        store.createIndex(table_Index[table], [key_Path[table]], { unique: false });
      } catch (error) {}
    })
  }
}
